<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <ChangePassword :id="customer_id" />
    <div class="container">
      <!-- Header com botão voltar e título -->
      <div class="row align-items-center mb-3">
        <div class="col-auto">
          <v-btn class="btn-return" v-on:click="handleToBack" elevation="0">
            <i class="fas fa-arrow-left mr-2"></i>
            <span class="d-none d-sm-inline">Voltar</span>
          </v-btn>
        </div>
        <div class="col">
          <h3 class="title-pages mb-0">{{ name }}</h3>
        </div>
      </div>

      <!-- Sistema de Tabs melhorado -->
      <nav>
        <div class="nav nav-tabs nav-tabs-modern" id="nav-tab" role="tablist">
          <a
            @click="errors = []"
            class="nav-link active"
            id="nav-informacoes"
            data-toggle="tab"
            href="#informacoes"
            role="tab"
            aria-controls="informacoes"
            aria-selected="true"
          >
            <i class="fas fa-user mr-2"></i>
            <span>INFORMAÇÕES</span>
          </a>
          <a
            @click="errors = []"
            class="nav-link"
            id="nav-portal"
            data-toggle="tab"
            href="#portal"
            role="tab"
            aria-controls="portal"
            aria-selected="true"
          >
            <i class="fas fa-user mr-2"></i>
            <span>ACESSO PORTAL CLIENTE</span>
          </a>
          <a
            @click="errors = []"
            class="nav-link"
            id="nav-documentos"
            data-toggle="tab"
            href="#documentos"
            role="tab"
            aria-controls="documentos"
            aria-selected="false"
          >
            <i class="fas fa-id-card mr-2"></i>
            <span>DOCUMENTOS</span>
          </a>
          <a
            @click="errors = []"
            class="nav-link"
            id="nav-informacoes-endereco"
            data-toggle="tab"
            href="#informacoes-endereco"
            role="tab"
            aria-controls="informacoes-endereco"
            aria-selected="false"
          >
            <i class="fas fa-map-marker-alt mr-2"></i>
            <span>ENDEREÇO</span>
          </a>
          <a
            @click="errors = []"
            class="nav-link"
            id="nav-residentes"
            data-toggle="tab"
            href="#residentes"
            role="tab"
            aria-controls="residentes"
            aria-selected="false"
          >
            <i class="fas fa-users mr-2"></i>
            <span>RESIDENTES</span>
          </a>
        </div>
      </nav>

      <!-- Conteúdo das Tabs -->
      <b-overlay :show="loading" opacity="0.99">
        <div class="tab-content tab-content-modern">
          <!-- TAB: INFORMAÇÕES -->
          <div
            class="tab-pane fade show active"
            id="informacoes"
            role="tabpanel"
            aria-labelledby="nav-informacoes"
          >
            <WarningMessage
              v-if="!permission('edit', 'resident_relatives')"
              message="Você não tem permissão para modificar familiares"
            />

            <!-- Seção: Dados Pessoais -->
            <div class="form-section">
              <div class="form-section-header">
                <i class="fas fa-user-circle mr-2"></i>
                <h5 class="mb-0">Dados Pessoais</h5>
              </div>
              <div class="row">
                <div class="col-lg-8 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="name"
                    label="Nome Completo"
                    outlined
                    dense
                  />
                </div>
                <div class="col-lg-4 col-md-6 col-12">
                  <v-select
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="type_of_customer_id"
                    :items="typesOfCustomer"
                    label="Grau de parentesco"
                    dense
                    outlined
                    item-value="id"
                    item-text="name"
                  />
                </div>
              </div>
            </div>

            <!-- Seção: Contato -->
            <div class="form-section">
              <div class="form-section-header">
                <i class="fas fa-phone mr-2"></i>
                <h5 class="mb-0">Contato</h5>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-mask="'(##) # ####-####'"
                    v-model="first_phone"
                    label="1º Telefone"
                    outlined
                    dense
                    prepend-inner-icon="mdi-phone"
                  />
                </div>
                <div class="col-lg-3 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-mask="'(##) # ####-####'"
                    v-model="second_phone"
                    label="2º Telefone"
                    outlined
                    dense
                    prepend-inner-icon="mdi-phone"
                  />
                </div>
              </div>
            </div>

            <!-- Seção: Informações Adicionais -->
            <div class="form-section">
              <div class="form-section-header">
                <i class="fas fa-info-circle mr-2"></i>
                <h5 class="mb-0">Informações Adicionais</h5>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-6">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    type="date"
                    v-model="date_of_birth"
                    label="Data de nascimento"
                    outlined
                    dense
                  />
                  <div
                    v-if="date_of_birth && date_of_birth.length == 10"
                    class="age-display"
                  >
                    <i class="fas fa-birthday-cake mr-1"></i>
                    <span
                      >{{
                        getAge(formatDateToUs(date_of_birth, true))
                      }}
                      anos</span
                    >
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-6">
                  <v-select
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="gender_id"
                    :items="genders"
                    label="Gênero"
                    dense
                    outlined
                    item-value="id"
                    item-text="name"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-6">
                  <v-select
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="marital_status_id"
                    :items="maritalStatus"
                    label="Estado civil"
                    dense
                    outlined
                    item-value="id"
                    item-text="name"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-6">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    type="text"
                    v-model="ie"
                    label="IE"
                    outlined
                    dense
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-6">
                  <v-select
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="status"
                    :items="[{ name: 'ATIVO' }, { name: 'INATIVO' }]"
                    label="Status"
                    dense
                    outlined
                    item-value="name"
                    item-text="name"
                  />
                </div>
              </div>
            </div>

            <!-- Mensagens e Ações -->
            <div class="form-actions">
              <div class="row align-items-center">
                <div class="col-lg-6 col-12 mb-3 mb-lg-0">
                  <WarningRequiredFields
                    v-if="permission('edit', 'resident_relatives')"
                  />
                  <ErrorsMessages :errors="errors" />
                  <div class="metadata-info">
                    <small class="d-block text-muted">
                      <i class="far fa-calendar-plus mr-1"></i>
                      Criação: {{ formatDate(created_at) }}
                    </small>
                    <small class="d-block text-muted">
                      <i class="far fa-calendar-check mr-1"></i>
                      Última alteração: {{ formatDate(updated_at) }}
                    </small>
                  </div>
                </div>
                <div class="col-lg-6 col-12 text-lg-right">
                  <div class="btn-group-actions">
                    <v-btn
                      v-if="permission('read', 'resident')"
                      type="button"
                      @click="handlePrint"
                      class="btn-print"
                      elevation="1"
                    >
                      <i class="fas fa-print mr-2"></i>
                      IMPRIMIR
                    </v-btn>

                    <confirmation-dialog
                      v-if="permission('edit', 'resident_relatives')"
                      message-title="EXCLUIR"
                      message-body="Deseja realmente excluir o familiar?"
                      open-class="btn-delete"
                      open-left-icon="fa-trash"
                      open-text="EXCLUIR"
                      @yes="deleteCustomer()"
                    />

                    <v-btn-timeout
                      v-if="permission('edit', 'resident_relatives')"
                      :disabled="loadingUpdate"
                      @click="update"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TAB: PORTAL -->
          <div
            class="tab-pane fade"
            id="portal"
            role="tabpanel"
            aria-labelledby="nav-portal"
          >
            <WarningMessage
              v-if="!permission('edit', 'resident_relatives')"
              message="Você não tem permissão para modificar familiares"
            />
            <!-- Seção: Acesso -->
            <div class="form-section">
              <div class="form-section-header">
                <i class="fas fa-phone mr-2"></i>
                <h5 class="mb-0">Acesso</h5>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    type="email"
                    v-model="email"
                    label="E-mail"
                    outlined
                    dense
                    prepend-inner-icon="mdi-email"
                  />
                </div>
                <div class="col-lg-6 col-12">
                  <v-text-field
                    type="password"
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="password"
                    label="Senha"
                    outlined
                    dense
                    prepend-inner-icon="mdi-lock"
                  />
                  <small class="text-muted"
                    >Se informar a senha, será auterada automáticamente!</small
                  >
                </div>
              </div>
            </div>

            <!-- Mensagens e Ações -->
            <div class="form-actions">
              <div class="row align-items-center">
                <div class="col-lg-6 col-12 mb-3 mb-lg-0">
                  <WarningRequiredFields
                    v-if="permission('edit', 'resident_relatives')"
                  />
                  <ErrorsMessages :errors="errors" />
                  <div class="metadata-info">
                    <small class="d-block text-muted">
                      <i class="far fa-calendar-plus mr-1"></i>
                      Criação: {{ formatDate(created_at) }}
                    </small>
                    <small class="d-block text-muted">
                      <i class="far fa-calendar-check mr-1"></i>
                      Última alteração: {{ formatDate(updated_at) }}
                    </small>
                  </div>
                </div>
                <div class="col-lg-6 col-12 text-lg-right">
                  <div class="btn-group-actions">
                    <v-btn
                      v-if="permission('read', 'resident')"
                      type="button"
                      @click="handlePrint"
                      class="btn-print"
                      elevation="1"
                    >
                      <i class="fas fa-print mr-2"></i>
                      IMPRIMIR
                    </v-btn>

                    <v-btn-timeout
                      v-if="permission('edit', 'resident_relatives')"
                      :disabled="loadingUpdate"
                      @click="updateEmail"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TAB: DOCUMENTOS -->
          <div
            class="tab-pane fade"
            id="documentos"
            role="tabpanel"
            aria-labelledby="nav-documentos"
          >
            <div class="form-section">
              <div class="form-section-header">
                <i class="fas fa-id-card mr-2"></i>
                <h5 class="mb-0">Documentação</h5>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-6 col-12">
                  <VTextFieldCPF
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-mask="'###.###.###-##'"
                    v-model="cpf"
                  />
                </div>
                <div class="col-lg-3 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="rg"
                    label="RG"
                    outlined
                    dense
                  />
                </div>
                <div class="col-lg-3 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="issuing_body"
                    label="Órgão expedidor"
                    outlined
                    dense
                  />
                </div>
                <div class="col-lg-3 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    type="date"
                    v-model="date_of_issue"
                    label="Data de emissão"
                    outlined
                    dense
                  />
                </div>
              </div>
            </div>

            <div class="form-actions">
              <ErrorsMessages :errors="errors" />
              <div class="text-right">
                <v-btn-timeout
                  v-if="permission('edit', 'resident_relatives')"
                  :disabled="loadingUpdate"
                  @click="update"
                />
              </div>
            </div>
          </div>

          <!-- TAB: ENDEREÇO -->
          <div
            class="tab-pane fade"
            id="informacoes-endereco"
            role="tabpanel"
            aria-labelledby="nav-informacoes-endereco"
          >
            <div class="form-section">
              <div class="form-section-header">
                <i class="fas fa-map-marker-alt mr-2"></i>
                <h5 class="mb-0">Endereço Completo</h5>
              </div>
              <div class="row">
                <div class="col-lg-2 col-md-4 col-12">
                  <VTextFieldCEP
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="cep"
                    @retrieved="evOnCEPRetrieved"
                  />
                </div>
                <div class="col-lg-7 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="address"
                    label="Endereço"
                    outlined
                    dense
                  />
                </div>
                <div class="col-lg-3 col-md-2 col-6">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="number_address"
                    label="Número"
                    outlined
                    dense
                  />
                </div>
                <div class="col-lg-4 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="neighborhood"
                    label="Bairro"
                    outlined
                    dense
                  />
                </div>
                <div class="col-lg-5 col-md-6 col-12">
                  <v-text-field
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="city"
                    label="Cidade"
                    outlined
                    dense
                  />
                </div>
                <div class="col-lg-3 col-md-6 col-12">
                  <v-select
                    :disabled="!permission('edit', 'resident_relatives')"
                    v-model="uf_id"
                    :items="ufs"
                    label="Estado"
                    dense
                    outlined
                    item-value="id"
                    item-text="name"
                  />
                </div>
              </div>
            </div>

            <div class="form-actions">
              <div class="text-right">
                <v-btn-timeout
                  v-if="permission('edit', 'resident_relatives')"
                  :disabled="loadingUpdate"
                  @click="update"
                />
              </div>
            </div>
          </div>

          <!-- TAB: RESIDENTES -->
          <div
            class="tab-pane fade"
            id="residentes"
            role="tabpanel"
            aria-labelledby="nav-residentes"
          >
            <CustomerHasResident :customer_id="customer_id" />
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import WarningMessage from "../templates/Components/WarningMessage";
import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import VBtnTimeout from "../templates/Components/VBtnTimeout";
import VTextFieldCEP from "../templates/Components/VTextFieldCEP.vue";
import VTextFieldCPF from "../templates/Components/VTextFieldCPF.vue";
import CustomerHasResident from "../templates/Customer/Resident";
import ChangePassword from "../templates/Customer/Password";
import api from "../services/api";
import toast from "../lib/ToastNotification";
import permission from "../lib/permission";
import { formatDate, formatDateToUs } from "../lib/format";
import { getAge } from "../lib/getAgeByDate";
import routes from "../routes";
import { getStatic } from "../lib/functions";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

export default {
  name: "Customer",

  components: {
    NavBar,
    CustomerHasResident,
    ChangePassword,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    VBtnTimeout,
    VTextFieldCEP,
    VTextFieldCPF,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      search: "",
      timeout: 30,
      stepCustomer: 1,
      customers: [],
      typesOfCustomer: [],
      maritalStatus: [],
      genders: [],
      ufs: [],
      customer_id: "",
      type_of_customer_id: "",
      gender_id: "",
      marital_status_id: "",
      uf_id: "",
      name: "",
      kinship: "",
      rg: "",
      cpf: "",
      issuing_body: "",
      date_of_issue: "",
      first_phone: "",
      second_phone: "",
      email: "",
      password: "",
      date_of_birth: "",
      cep: "",
      address: "",
      number_address: "",
      complement: "",
      city: "",
      neighborhood: "",
      ie: "",
      status: "ATIVO",
      loadingCreate: false,
      loadingUpdate: false,
      loading: true,
      created_at: "",
      updated_at: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    getAge,
    formatDate,
    formatDateToUs,

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async retrieve() {
      const { id } = routes.history.current.params;
      this.customer_id = id;
      await this.get();

      try {
        this.ufs = (await getStatic("/ufs", true)).ufs;
        this.genders = (await getStatic("/genders", true)).genders;
        this.maritalStatus = (
          await getStatic("/rest-home/marital-status/all", true)
        ).marital_status;
        this.typesOfCustomer = (
          await getStatic("/types-of-customers", true)
        ).types;
      } catch (errors) {
        this.errors = errors;
      }
    },

    async update() {
      try {
        this.loadingUpdate = true;
        this.timeout = 30;

        const {
          customer_id,
          type_of_customer_id,
          gender_id,
          marital_status_id,
          uf_id,
          name,
          kinship,
          first_phone,
          second_phone,
          email,
          date_of_birth,
          rg,
          cpf,
          issuing_body,
          date_of_issue,
          cep,
          address,
          number_address,
          city,
          neighborhood,
          ie,
          status,
        } = this;

        let params = {
          id: customer_id,
          type_of_customer_id,
          gender_id,
          marital_status_id,
          uf_id,
          name,
          first_phone,
          second_phone,
          email,
          date_of_birth,
          kinship,
          rg,
          cpf,
          issuing_body,
          date_of_issue,
          cep,
          address,
          number_address,
          city,
          neighborhood,
          ie,
          status,
        };

        const response = await api.patch("/rest-home/customer/", params);
        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
          this.timeout = 0;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateEmail() {
      try {
        this.loadingUpdate = true;
        this.timeout = 30;

        const { customer_id, email, password } = this;

        let params = { id: customer_id, email, password };

        const response = await api.patch(
          "/rest-home/customer/emailpass",
          params
        );
        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
          this.timeout = 0;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async get() {
      try {
        this.stepCustomer = 1;
        this.loading = true;

        const { customer_id } = this;
        const response = await api.get("/rest-home/customer", {
          params: { id: customer_id },
        });

        const { customer, error } = response.data;

        if (error) {
          return routes.push({ name: "customers" });
        }

        this.type_of_customer_id = customer.type_of_customer_id;
        this.gender_id = customer.gender_id || "";
        this.marital_status_id = customer.marital_status_id || "";
        this.uf_id = customer.uf_id || "";
        this.name = customer.name;
        this.kinship = customer.kinship;
        this.rg = customer.rg;
        this.cpf = customer.cpf;
        this.issuing_body = customer.issuing_body;
        this.date_of_issue = formatDateToUs(customer.date_of_issue);
        this.first_phone = customer.first_phone;
        this.second_phone = customer.second_phone;
        this.email = customer.email;
        this.date_of_birth = formatDateToUs(customer.date_of_birth);
        this.cep = customer.cep;
        this.address = customer.address;
        this.number_address = customer.number_address;
        this.city = customer.city;
        this.neighborhood = customer.neighborhood;
        this.ie = customer.ie;
        this.status = customer.status == 1 ? "ATIVO" : "INATIVO";
        this.created_at = customer.created_at;
        this.updated_at = customer.updated_at;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteCustomer() {
      try {
        this.loading = true;

        const data = { id: this.customer_id };
        const response = await api.delete("/rest-home/customer", { data });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$router.push({ name: "customers" });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    handlePrint() {
      const { customer_id: id } = this;
      let route = this.$router.resolve({
        name: "print_customer",
        params: { id },
      });
      window.open(route.href, "_blank");
    },

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style scoped>
/* Tabs Modernizadas */
.nav-tabs-modern {
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 1.5rem;
}

.nav-tabs-modern .nav-link {
  color: #666;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-bottom: -2px;
}

.nav-tabs-modern .nav-link:hover {
  color: #33495e;
  border-bottom-color: #33495e50;
  background-color: transparent;
}

.nav-tabs-modern .nav-link.active {
  color: #33495e;
  border-bottom-color: #33495e;
  background-color: transparent;
}

.nav-tabs-modern .nav-link i {
  font-size: 1rem;
}

/* Responsividade das tabs */
@media (max-width: 768px) {
  .nav-tabs-modern .nav-link {
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
  }

  .nav-tabs-modern .nav-link span {
    display: none;
  }

  .nav-tabs-modern .nav-link i {
    margin-right: 0 !important;
    font-size: 1.25rem;
  }
}

/* Conteúdo das tabs */
.tab-content-modern {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Seções de formulário */
.form-section {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e9ecef;
}

.form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.form-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #f0f0f0;
}

.form-section-header h5 {
  color: #33495e;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-section-header i {
  color: #33495e;
  font-size: 1.1rem;
}

/* Display de idade */
.age-display {
  color: #666;
  font-size: 0.875rem;
  margin-top: -0.5rem;
  padding-left: 0.25rem;
}

.age-display i {
  color: #33495e;
}

/* Ações do formulário */
.form-actions {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 2px solid #f0f0f0;
}

/* Metadados */
.metadata-info {
  margin-top: 0.5rem;
}

.metadata-info small {
  line-height: 1.8;
}

.metadata-info i {
  color: #33495e;
  width: 16px;
}

/* Grupo de botões de ação */
.btn-group-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

@media (max-width: 991px) {
  .btn-group-actions {
    justify-content: stretch;
  }

  .btn-group-actions > * {
    flex: 1;
  }
}

/* Melhorias no botão voltar */
.btn-return {
  background-color: #fff !important;
  border: 1px solid #ddd !important;
  color: #33495e !important;
  transition: all 0.3s ease;
}

.btn-return:hover {
  background-color: #f8f9fa !important;
  border-color: #33495e !important;
  transform: translateX(-2px);
}

/* Espaçamento responsivo */
@media (max-width: 576px) {
  .tab-content-modern {
    padding: 1rem;
  }

  .form-section {
    margin-bottom: 1.5rem;
  }

  .form-section-header {
    margin-bottom: 1rem;
  }
}

/* Acessibilidade - foco visível */
.nav-tabs-modern .nav-link:focus {
  outline: 2px solid #33495e;
  outline-offset: 2px;
}

button:focus,
.v-btn:focus {
  outline: 2px solid #33495e;
  outline-offset: 2px;
}
</style>